import router from '@/router';
import { CredentialService } from '@/services/CredentialService';
import store from '@/store';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_DEV_URL;
let isLoggedIn = false;
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  // Enable credentials for CORS
  withCredentials: true,
});

// Add method to set custom headers
api.setCustomHeaders = (headers) => {
  api.defaults.headers.common = {
    ...api.defaults.headers.common,
    ...headers,
  };
};

api.interceptors.request.use(
  (config) => {
    const credential = CredentialService.getCredential();
    const authToken = credential.accessToken;

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error.message);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      const status = error.response.status;
      const code = error.response.data?.code;

      const sessionExpired = (code === 'SESSION_EXPIRED' && status === 401) || status == 401;

      const token = CredentialService.getCredential()?.accessToken;
      const isExpired = isTokenExpired(token);
      if ([403].includes(status) || sessionExpired || isExpired) {
        await store.dispatch('userPermission/resetUserPermissionsState');
        localStorage.clear();
        await store.dispatch('logout');
        if (router.currentRoute.path !== '/login') {
          try {
            await router.replace('/login').catch((er) => {
              this.$router.push({ path: `/login` });
            });
          } catch (er) {}
        }
      }
    } else {
    }
    return Promise.reject(error);
  }
);

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const [, payloadBase64] = token.split('.');
    const payload = JSON.parse(atob(payloadBase64));
    const now = Date.now() / 1000;
    return payload.exp < now;
  } catch (e) {
    return true;
  }
}
export { isTokenExpired };

export default api;
